import { Icon } from "./Icon.js";

interface StatusBannerProps {
  readonly body: string;
  readonly live?: boolean;
  readonly title: string;
  readonly tone: "calm" | "notice";
}

export function StatusBanner({ body, live = false, title, tone }: StatusBannerProps) {
  return (
    <section
      aria-live={live ? "polite" : undefined}
      className={`status-banner status-banner--${tone}`}
    >
      <span className="status-banner__icon">
        <Icon name={tone === "calm" ? "shield" : "alert"} />
      </span>
      <div>
        <h2>{title}</h2>
        <p>{body}</p>
      </div>
    </section>
  );
}
